import React from 'react';
import { Icon } from './Icon.js';
export const IconHouseBookmark = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M11 21H3V8.75L12 2L21 8.75V10", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M15 14H21V21.5L18 20L15 21.5V14Z", stroke: "currentColor", strokeWidth: "2", fill: "none" })));
};
//# sourceMappingURL=IconHouseBookmark.js.map